import { Avatar } from "@mui/material"

export const AvatarImg = ({ id, image, openImage }) => {
    return (
        <Avatar
            variant="square"
            id={id}
            alt={"user"}
            src={image || ""}
            role="button"
            sx={{
                height: 35,
                width: 35,
                borderRadius: 10,
            }}
            onClick={openImage && image ? () => openImage(image) : null}
        />
    )
}
